import { jwtDecode } from "jwt-decode";
import { Navigate, Outlet } from "react-router";

import { CONSTANTS } from "../constants";
import { headers } from "../network";
import { RoleType } from "../types";

type PrivateRouteProps = {
  allowedRoles?: RoleType[];
};

export const ProtectedRoute = ({ allowedRoles }: PrivateRouteProps) => {
  const { authorization } = headers;

  try {
    const decoded: { role: RoleType; username: string } = jwtDecode(
      authorization || ""
    );

    if (decoded.role && !allowedRoles?.includes(decoded.role)) {
      return <Navigate to={CONSTANTS.ROUTES.notAllowed} />;
    }

    return (
      <Outlet
        context={{ username: decoded?.username || "", role: decoded.role }}
      />
    );
  } catch (error) {
    return <Navigate to={CONSTANTS.ROUTES.login} />;
  }
};
